var _defs, _defs2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleWorkspaceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -100 5000 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h4400v612H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5f6368",
    d: "M2087 39h47l-94 350h-46l-75-231h-2l-76 231h-46l-97-350h47l74 275h2l76-228h42l76 228h2l70-275z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5f6368",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2129 269q0-55 35-91t89-36 88 36q35 36 35 91 0 56-35 92t-88 36-89-36q-35-36-35-92m45 0q0 39 23 63t56 24q33 0 56-24t22-63q0-38-22-62-23-24-56-24t-56 24q-23 24-23 62M2453 389h-45V149h43v40h2q7-20 29-33t42-14q19 0 33 6l-14 44q-8-3-26-3-26 0-45 20t-19 48zM2789 389h-55l-74-113-37 37v76h-45V39h45v216l104-106h57v2l-93 93 98 143v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2984 323q0 31-27 53t-70 21q-36 0-63-19a104 104 0 01-39-49l40-17q9 21 25 33a62 62 0 0037 12q22 0 36-9t15-22q0-23-35-34l-42-10q-70-18-70-68 0-33 27-53t68-20q32 0 58 16t36 40l-40 17a51 51 0 00-22-24 70 70 0 00-35-8 58 58 0 00-32 8q-14 9-14 22 0 21 39 29l36 10q72 17 72 72M3140 397q-26 0-48-11t-33-30h-2l2 33v106h-45V149h43v34h2q11-19 33-30t49-11q47 0 80 37 34 37 34 90 0 54-34 91-33 37-80 37m-8-41q33 0 55-24t22-63q0-37-22-62t-55-24q-33 0-55 24-21 25-21 62 0 39 21 63 22 24 55 24M3378 142q50 0 79 26t29 73v148h-43v-33h-2q-28 41-75 41-39 0-66-23t-27-59q0-37 28-59t76-22q40 0 66 14v-10q0-24-19-40a64 64 0 00-43-16q-38 0-60 32l-40-25q33-47 97-47m-58 174q0 18 15 29t35 12q28 0 50-21t23-49q-21-17-59-17-27 0-46 13t-18 33M3639 397q-54 0-89-36-35-37-35-92t35-91q35-36 89-36 37 0 64 18t41 51l-41 17q-19-45-67-45-31 0-54 25-22 25-22 61t22 62q23 25 54 25 49 0 69-45l41 17q-14 33-42 51t-65 18M3881 397q-53 0-87-36t-34-92q0-54 33-91t85-36q54 0 85 34t32 97v5h-189q1 35 23 57t54 21q43 0 68-43l40 20a120 120 0 01-45 47q-28 17-65 17m-72-157h138q-2-25-20-41t-50-16q-25 0-43 15t-25 42"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M202 236v-55h182a178 178 0 013 34c0 40-11 91-47 126-35 37-79 56-139 56C92 397 0 308 0 199S92 0 201 0c61 0 104 24 137 55l-39 38A142 142 0 0059 199c0 80 63 144 142 144 52 0 82-21 101-40 15-15 25-37 29-67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M664 269c0 74-58 128-129 128s-128-54-128-128 58-128 128-128 129 54 129 128m-57 0c0-46-33-77-72-77s-72 31-72 77 34 78 72 78 72-32 72-78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc04",
    d: "M944 269c0 74-58 128-129 128s-128-54-128-128 58-128 128-128 129 54 129 128m-57 0c0-46-33-77-72-77s-72 31-72 77 34 78 72 78 72-32 72-78"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    d: "M1212 149v230c0 94-56 133-122 133-62 0-99-42-113-76l49-20c9 21 30 46 64 46 43 0 69-27 69-75v-19h-2a87 87 0 01-68 29c-63 0-122-56-122-127 0-72 59-129 122-129 31 0 55 14 68 29h2v-21zm-49 121c0-45-30-78-69-78-38 0-71 33-71 78 0 44 33 77 71 77 39 0 69-33 69-77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    d: "M1251 15h56v375h-56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    d: "M1524 311l44 30c-14 20-48 56-107 56-73 0-127-56-127-128 0-76 55-128 121-128s99 53 109 82l6 14-171 71c13 26 33 39 62 39s48-14 63-36m-134-46l114-47c-6-16-25-27-47-27-29 0-69 25-67 74"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleWorkspaceLogo);
export default __webpack_public_path__ + "static/media/google-workspace-logo.18106442d2c9c1a39fcc61b0ab982ab4.svg";
export { ForwardRef as ReactComponent };